import React from 'react';

const ClonePlateFormat = (props) => {
    return (
        <div className="vehicle-plate" style={props.style}>
            <div className={"product-heading " + (props.value?.pattern ?? 'WITHOUT_PATTERN')}></div>
            <div className={"product-body " + (props.value?.pattern ?? 'WITHOUT_PATTERN')}>
                {props.value?.formattedValue}
            </div>
        </div>
    );
};

export default ClonePlateFormat;